








import { Component, Vue } from 'vue-property-decorator';
import AppModal from '@/components/AppModal.vue';
import db from '@/services/firestore';
import firebase from 'firebase';
import spawns from '../data/spawns.json';

@Component({
  components: {
    AppModal
  }
})
export default class SeedView extends Vue {
  async seed() {
    const collection = db.collection('spawns');

    (await collection.get()).forEach((spawn) => {
      spawn.ref.delete();
    });

    spawns.forEach((spawn: any[]) => {
      const [lat, lng, type] = spawn;
      collection.add({
        type,
        coordinates: new firebase.firestore.GeoPoint(lat, lng),
        lat,
        lng,
        cooldown: new Date()
      });
    });
  }
}
